import { Field } from "formik";
import ValidationError from "./ValidationError";
import { IValidatedField } from "../../interfaces/form";

export default function ValidatedField(props: IValidatedField) {
  const { wrapper, wrapperAdditionalClasses, ...rest } = props;
  if (wrapper) {
    return (
      <span
        className={`position-relative${
          wrapperAdditionalClasses ? " " + wrapperAdditionalClasses : ""
        }`}
      >
        <FieldAndValidation {...rest} />
      </span>
    );
  }
  return <FieldAndValidation {...rest} />;
}

function FieldAndValidation(props: IValidatedField) {
  const { error, touched, additionalClasses, locked, ...rest } = props;
  return (
    <>
      <Field
        disabled={locked}
        className={`form-control${error && touched ? " is-invalid" : ""}${
          additionalClasses ? " " + additionalClasses : ""
        }`}
        {...rest}
      />
      <ValidationError error={error} show={touched} />
    </>
  );
}
